"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceIsHighRisk = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdultServiceIsHighRisk = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.adult_service_is_high_risk.label',
    fallbackLabel: 'Could you please confirm if merchants operating within this segment are classified as high risk, subject to enhanced due diligence measures, and if their ongoing due diligence is conducted on an annual basis?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
